import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'

import { useTranslation } from 'react-i18next'
import Spinner from './Spinner'

const SpinnerDialog = ({ open }) => {
  const { t } = useTranslation()
  return (
    <Dialog open={open}>
      <DialogContent
        sx={{
          height: 300,
          width: 300,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="body1">{t('general.please_wait')}</Typography>
        <Spinner />
      </DialogContent>
    </Dialog>
  )
}

export default SpinnerDialog
